/* eslint-disable import/prefer-default-export */
import headers from "app/requests/headers";

export const get = (id) => (
  fetch(`/api/public/tests/${id}/responses`, {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);

export const update = (id, params) => (
  fetch(`/api/public/tests/${id}/responses`, {
    body: JSON.stringify(params),
    headers: headers(),
    method: "PUT"
  }).then((response) => response.json())
);
